/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { call, put, take, takeEvery, select } from 'redux-saga/effects';
import { requestApi, parseResponse } from 'src/providers/http-api.provider';
import { GET_USER_INFO, GET_USER_LICENSES } from 'src/types/user-action.type';
import { getPrettierMessage, getSortedList } from 'src/utils/global';
import { getUserInfoError, getUserInfoSuccess, getUserLicensesError, getUserLicensesSuccess } from '../actions/user.action';
import { ApiPlatformUrl } from 'src/utils/config';
import { AppMessages } from 'src/constants/messages.constant';
import { setCurrentLicense } from '../actions/settings.action';

function* onGetUserLicenses():any {

  let errorMessage = '';
  try {
    const accessToken = yield select(state => state.auth?.accessToken);
    if (accessToken ) {
      const endpoint = `${ApiPlatformUrl}/Users/GetUserLicenses`;
      let response = yield call(requestApi, {
        endpoint,
        method: 'GET',
        headers: {
          Authorization: accessToken,
        },
        useParseResponse: false,
      });
      if (response?.ok) {
        let licensesData = yield call(parseResponse, response);
        if (licensesData.length > 0) {
          let licenseDefault = licensesData?.find((item:any) => item.isOwner) || licensesData[0];
          yield put(getUserLicensesSuccess(licensesData));
          yield put(setCurrentLicense(licenseDefault));
        } else {
          yield put(getUserLicensesSuccess([]));
        }
      } else {
        const apiError = yield call(parseResponse, response);
        let apiErrorMessage = getPrettierMessage(apiError?.Message);
        if (apiErrorMessage) {
          errorMessage =`${apiErrorMessage} ${AppMessages.REINTENT_LABEL}`;
        }
        throw new Error(errorMessage);
      }
    } else {
      throw new Error("accessToken empty");
    }
  } catch (err) {
    console.log("Fail onGetUserLicenses: ", err);
    yield put(getUserLicensesError(err || AppMessages.ERROR_GENERIC));
  }
}

function* onGetUserInfo():any {
  let errorMessage = '';
  try {
    const accessToken = yield select(state => state.auth?.accessToken);
    if (accessToken ) {
      const endpoint = `${ApiPlatformUrl}/Users/GetCurrentUserInfo`;
      let response = yield call(requestApi, {
        endpoint,
        method: 'GET',
        headers: {
          Authorization: accessToken,
        },
        useParseResponse: false,
      });
      if (response?.ok) {
        let userData = yield call(parseResponse, response);
        if (userData) {
          yield put(getUserInfoSuccess(userData));
        } else {
          yield put(getUserLicensesSuccess(null));
        }
      } else {
        const apiError = yield call(parseResponse, response);
        let apiErrorMessage = getPrettierMessage(apiError?.Message);
        if (apiErrorMessage) {
          errorMessage =`${apiErrorMessage} ${AppMessages.REINTENT_LABEL}`;
        }
        throw new Error(errorMessage);
      }
    } else {
      throw new Error("accessToken empty");
    }
  } catch (err) {
    console.log("Fail onGetUserInfo: ", err);
    yield put(getUserInfoError(err || AppMessages.ERROR_GENERIC));
  }
}

export function* watchOnGetUserLicenses() {
  yield takeEvery(GET_USER_LICENSES, onGetUserLicenses);
}

export function* watchOnGetUserInfo() {
  yield takeEvery(GET_USER_INFO, onGetUserInfo);
}
